const tagsModel = vm => ({
  title: vm.$gettext('Tags'),
  endpoint: 'tags',
  allowNew: true,
  allowDelete: true,
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'name',
      label: vm.$gettext('Name'),
      sortable: true,
      editable: true,
      required: true,
      toLowerCase: true
    }
  ],
  filters: ['id', 'name']
})

export default tagsModel
